import GitHubSvg from '@/icons/github.svg?react'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Avatar: FunctionalComponent<{
  src?: string | null
  size?: number
}> = props => {
  return (
    <div
      class={styles.root}
      style={{
        width: props.size ?? 30,
        height: props.size ?? 30,
      }}
    >
      {props.src ? <img src={props.src} alt='' /> : <GitHubSvg class={styles.placeholder} />}
    </div>
  )
}
